import { render, staticRenderFns } from "./PayEditor.vue?vue&type=template&id=39fdb278&"
import script from "./PayEditor.vue?vue&type=script&lang=js&"
export * from "./PayEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports